import { Add as AddIcon } from '@mui/icons-material';
import { CommonButton } from './CommonButton';

interface AddNotificationButtonProps {
  onAddClick: () => void;
}

export const AddNotificationButton = ({ onAddClick }: AddNotificationButtonProps) => {
  return (
    <CommonButton
      startIcon={<AddIcon />}
      onClick={onAddClick}
    >
      새 알림 추가
    </CommonButton>
  );
}; 